<!-- 组队瓜分奖品 -->
<template>
  <div class="createPlayStep new-input-box" v-loading="loading">
    <!-- 头部返回 -->
    <div class="backBox">
      <jd-back
        @back="returnBack()"
        :title="['互动广场']"
        :subTitle="activityData.name"
        style="padding-bottom: 0"
      ></jd-back>
    </div>
    <div class="formBox">
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="localStepNum">
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>

      <!-- 活动条件表单设置 -->
      <div class="secondstep" v-if="localStepNum == 0 || localStepNum == 1">
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          class="backgroundForm"
          label-width="150px"
        >
          <informationForm
            @selectPeopleSure="selectPeopleSure"
            @getMemberFn="getMemberFn"
            :defaultActMember.sync="actMember"
            :defaultActivityStartTime="activityStartTime"
            :defaultActivityEndTime="activityEndTime"
            :plusObject.sync="ruleDTO.plusObject"
            :openCardStartTime.sync="ruleDTO.openCardStartTime"
            :openCardEndTime.sync="ruleDTO.openCardEndTime"
            :peopleSelected.sync="peopleSelected"
            ref="informationForm"
            v-model="ruleForm"
            :isEdit="false"
            :disabled="activityData.isStart"
            :localStepNum="localStepNum"
            :needNonMember="true"
            :activityId="69"
            :showOpenCardTip="true"
            :customerPaperwork="customerPaperwork"
            @handlCorwdTips="customerPaperwork = $event;$forceUpdate()"
          >
          </informationForm>
          <jd-title label="砍价设置"></jd-title>
          <div class="mt20">
            <el-form-item label="砍价类型：" required>
              <el-radio-group
                v-model="bargainConfig.bargainType"
                @change="changeBargainType"
                :disabled="activityData.isStart"
              >
                <el-radio :label="0">按砍价金额</el-radio>
                <el-radio :label="1">按邀请人数</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="指定商品：" required>
              <jd-table :tableData="specifytList" :tableInfo="tableInfo">
                <template #logoSlot="{ row }">
                  <img
                    v-if="row.logo"
                    class="logo-style"
                    :src="row.logo"
                    alt=""
                  />
                </template>
                <template #titleSlot="{ row }">
                  <el-input
                    v-model="row.skuName"
                    maxlength="12"
                    :disabled="backgroundOpacity || !row.skuName"
                    show-word-limit
                    style="width: 250px"
                    placeholder="请输入"
                  ></el-input>
                </template>
                <template #priceSlot="{ row }">
                  <div v-if="row.jdPrice">￥{{ row.jdPrice }}</div>
                </template>
                <template #actionSlot="{ row }">
                  <div class="flexc-cen-x">
                    <jd-button
                      type="blueText"
                      :disabled="activityData.isStart"
                      label="选择商品"
                      @click="selectGoodsFn(row)"
                    ></jd-button>
                    <el-upload
                      action="/jd-hd-web/image/upload"
                      :show-file-list="false"
                      :on-success="(res) => uploadLogo(res, row)"
                      :before-upload="(file) => beforeUploadPrize(file)"
                      list-type="picture"
                      ref="uploadRef"
                      :disabled="backgroundOpacity"
                      class="ml12"
                    >
                      <jd-button
                        :disabled="backgroundOpacity"
                        type="blueText"
                      >
                        上传商品图片
                      </jd-button>
                    </el-upload>
                  </div>
                </template>
              </jd-table>
            </el-form-item>
            <div v-if="bargainConfig.bargainType == 0">
              <el-form-item label="首砍说明：">
                <div>
                  用户参与活动时，点击参与砍价时所获取的价格的值，为用户带来首砍高价值的感受更愿意邀请好友参与
                  <span class="text-red">（建议配置不高于首个奖品减价的值，否则用户自砍即可领取首个专属价）</span>
                </div>
              </el-form-item>
              <el-form-item label="首砍金额：" required>
                <el-input
                  v-model="bargainConfig.firstBargainAmountLowerLimit"
                  class="w90"
                  placeholder="请输入"
                  @input="
                    bargainConfig.firstBargainAmountLowerLimit =
                      getPriceNum($event)
                  "
                  @blur="
                    bargainConfig.firstBargainAmountLowerLimit =
                      getPriceNumLimit(
                        $event,
                        'firstBargainAmountUpperLimit',
                        'first'
                      )
                  "
                ></el-input>
                <span class="mlr8">元~</span>
                <el-input
                  v-model="bargainConfig.firstBargainAmountUpperLimit"
                  placeholder="请输入"
                  class="w90"
                  @input="
                    bargainConfig.firstBargainAmountUpperLimit =
                      getPriceNum($event)
                  "
                  @blur="
                    bargainConfig.firstBargainAmountUpperLimit =
                      getPriceNumLimit(
                        $event,
                        'firstBargainAmountLowerLimit',
                        'end'
                      )
                  "
                ></el-input>
                <span class="ml8">元</span>
                <div>注：配置后随机获取配置的价格区间为用户首砍价格</div>
              </el-form-item>
              <el-form-item label="邀请砍价金额：">
                <div class="invite-box">
                  <el-form-item label="新会员：" label-width="70px">
                    <el-input
                      v-model="bargainConfig.newMemberBargainAmountLowerLimit"
                      class="w90"
                      placeholder="请输入"
                      @input="
                        bargainConfig.newMemberBargainAmountLowerLimit =
                          getPriceNum($event)
                      "
                      @blur="
                        bargainConfig.newMemberBargainAmountLowerLimit =
                          getPriceNumLimit(
                            $event,
                            'newMemberBargainAmountUpperLimit',
                            'first'
                          )
                      "
                    ></el-input>
                    <span class="mlr8">元~</span>
                    <el-input
                      v-model="bargainConfig.newMemberBargainAmountUpperLimit"
                      placeholder="请输入"
                      class="w90"
                      @input="
                        bargainConfig.newMemberBargainAmountUpperLimit =
                          getPriceNum($event)
                      "
                      @blur="
                        bargainConfig.newMemberBargainAmountUpperLimit =
                          getPriceNumLimit(
                            $event,
                            'newMemberBargainAmountLowerLimit',
                            'end'
                          )
                      "
                    ></el-input>
                    <span class="ml8">元</span>
                  </el-form-item>
                  <el-form-item label="老会员：" label-width="70px">
                    <el-input
                      v-model="bargainConfig.oldMemberBargainAmountLowerLimit"
                      class="w90"
                      placeholder="请输入"
                      @input="
                        bargainConfig.oldMemberBargainAmountLowerLimit =
                          getPriceNum($event)
                      "
                      @blur="
                        bargainConfig.oldMemberBargainAmountLowerLimit =
                          getPriceNumLimit(
                            $event,
                            'oldMemberBargainAmountUpperLimit',
                            'first'
                          )
                      "
                    ></el-input>
                    <span class="mlr8">元~</span>
                    <el-input
                      v-model="bargainConfig.oldMemberBargainAmountUpperLimit"
                      placeholder="请输入"
                      class="w90"
                      @input="
                        bargainConfig.oldMemberBargainAmountUpperLimit =
                          getPriceNum($event)
                      "
                      @blur="
                        bargainConfig.oldMemberBargainAmountUpperLimit =
                          getPriceNumLimit(
                            $event,
                            'oldMemberBargainAmountLowerLimit',
                            'end'
                          )
                      "
                    ></el-input>
                    <span class="ml8">元</span>
                  </el-form-item>
                  <div>
                    注：新会员为非会员被邀请后通过当前活动加入会员用户；老会员则为已存在历史入会记录；
                  </div>
                </div>
              </el-form-item>
            </div>
            <el-form-item label="被邀请限制：">
              <el-radio-group
                v-model="bargainConfig.inviteLimitType"
                :disabled="activityData.isStart"
              >
                <el-radio :label="0">仅可帮单个好友砍价一次</el-radio>
                <el-radio :label="1">可帮多个好友砍价一次</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="奖品领取限制：">
              <el-radio
                v-model="winLimit"
                :label="0"
                :disabled="activityData.isStart"
                >仅可领取一次</el-radio
              >
            </el-form-item>
            <el-form-item label="奖品设置：" required>
              <jd-button
                type="lightBlue"
                :disabled="activityData.isStart || prizeList.length >= 3"
                @click="addPrizeList"
                >+添加奖品({{ prizeList.length }}/3)</jd-button
              >
              <span class="ml8"
                >注：最少配置一个专享价&令牌奖品，需根据商品优惠的价格由少到多排序</span
              >
              <jd-table
                class="mt16"
                :tableData="prizeList"
                :tableInfo="commonInfo"
              >
                <template #dailyLimit="{ row }">
                  <dailyLimitConfig
                    :row="row"
                    :backgroundOpacity="backgroundOpacity"
                    :limitBtnDisabled="backgroundOpacity"
                  ></dailyLimitConfig>
                </template>
                <template #inviteSlot="{ row }">
                  <el-input-number
                    style="width: 150px"
                    v-model="row.successInviteNum"
                    :disabled="activityData.isStart"
                    :min="''"
                  ></el-input-number>
                </template>
                <template #prizeTypeSlot="{ row }">
                  <span>{{ getPrizeTypeName(row.prizeType) }}</span>
                </template>
                <template #logoSlot="{ row }">
                  <img
                    v-if="row.logo"
                    class="logo-style"
                    :src="row.logo"
                    alt=""
                  />
                </template>
                <template #discountSlot="{ row, rowIndex }">
                  <el-input
                    v-model="row.reducePrice"
                    :disabled="
                      activityData.isStart ||
                      !row.prizeType ||
                      row.prizeType == 12
                    "
                    :class="
                      bargainConfig.bargainType == 1 || activityData.isStart
                        ? 'w150'
                        : 'w180'
                    "
                    @input="row.reducePrice = getNumberData(1, $event, 1, 0)"
                    @blur="getDisCountAmount(row, rowIndex)"
                    placeholder="请输入"
                  ></el-input>
                </template>
                <template #discountedSlot="{ row, rowIndex }">
                  <el-input
                    v-model="row.price"
                    :disabled="
                      activityData.isStart ||
                      !row.prizeType ||
                      row.prizeType == 12
                    "
                    :class="
                      bargainConfig.bargainType == 1 || activityData.isStart
                        ? 'w150'
                        : 'w180'
                    "
                    @input="row.price = getNumberData(1, $event, 1, 0)"
                    @blur="getDisCountedPrice(row, rowIndex)"
                    placeholder="请输入"
                  ></el-input>
                </template>
                <template #inventorySlot="{ row }">
                  <el-input
                    v-model="row.totalAmount"
                    :class="
                      bargainConfig.bargainType == 1 || activityData.isStart
                        ? 'w150'
                        : 'w180'
                    "
                    :disabled="activityData.isStart"
                    @input="
                      row.totalAmount = getNumberData(1, $event, 0, 1, 999999)
                    "
                    placeholder="请输入"
                  ></el-input>
                </template>
                <template #remanentAmountSlot="{ row }">
                  <el-input
                    v-model.number="row.remanentAmount"
                    class="w125"
                    disabled
                  ></el-input>
                  份
                </template>
                <template #actionSlot="{ row, rowIndex }">
                  <div class="flexc-cen-x">
                    <jd-button
                      type="blueText"
                      label="选择奖品"
                      :disabled="activityData.isStart || !specifytList[0].skuId"
                      @click="selectPrize(row, rowIndex)"
                    ></jd-button>
                    <el-upload
                      action="/jd-hd-web/image/upload"
                      :show-file-list="false"
                      :on-success="(res) => uploadLogo(res, row)"
                      :before-upload="(file) => beforeUploadPrize(file)"
                      list-type="picture"
                      ref="uploadRef"
                      :disabled="activityData.isStart || !row.logo"
                      class="ml20"
                    >
                      <jd-button
                        :disabled="activityData.isStart || !row.logo"
                        type="blueText"
                      >
                        上传奖品图
                      </jd-button>
                    </el-upload>
                    <jd-button
                      type="blueText"
                      class="ml20"
                      v-if="
                        activityData.isStart &&
                        !backgroundOpacity &&
                        row.remanentAmount
                      "
                      @click="addStock(row, rowIndex)"
                      >增加库存</jd-button
                    >
                    <jd-button
                      type="blueText"
                      :class="activityData.isStart ? '' : 'ml20'"
                      label="删除"
                      v-if="prizeList.length > 1 && rowIndex > 0"
                      :disabled="activityData.isStart"
                      @click="deletePrize(rowIndex)"
                    ></jd-button>
                  </div>
                </template>
              </jd-table>
            </el-form-item>
          </div>
          <activityPageSettings
            isShowShopName
            isShowMoreSet
            :cusTemplateJSON.sync="ruleDTO.cusTemplateJSON"
            :isNeedSetBG="true"
            :giftList="giftList"
            themeTitle="主题"
            :templateId="templateId"
            @selectTemplate="selectTemplate"
            :widthNumber="750"
            :heightNumber="2098"
            previewKey="url"
            templatekey="imageUrl"
            :isShowDesignNumber="false"
            :isCustomPreview="true"
            :defaultRgb="currrentRgb2"
            downloadTemplateUrl="https://cdn-image.yucrm.cn/images/yuqiyunzhou/activityPic/%E6%8B%BC%E5%9B%A2%E7%A0%8D%E4%BB%B7.psd"
            :designSpecificationsUrl="designSpecificationsList[activityData.id]"
            v-model="customerPaperwork"
          >
            <template #customPreview>
              <groupBargainingPreviewDialog
                :backgroundImage="ruleDTO.cusTemplateJSON"
                :customerPaperwork="customerPaperwork"
                :templateObj="templateObj"
                :specifytList="specifytList"
                :prizeList="prizeList"
                :bargainConfig="bargainConfig"
              ></groupBargainingPreviewDialog>
            </template>
            <template #otherSet>
              <el-form-item label="商品模块按钮背景图：" label-width="180px">
                <div class="buttonGroup">
                  <el-upload
                    class="upload"
                    action="/jd-hd-web/image/upload"
                    :show-file-list="false"
                    :before-upload="(file) => beforeUploadUI(file, 1)"
                    :on-success="(res) => handleUploadUI(res, 1)"
                  >
                    <div
                      class="btn-bg"
                      v-if="customerPaperwork.productModuleBtnUrl"
                    >
                      <img
                        :src="customerPaperwork.productModuleBtnUrl"
                        style="width: 81px; height: 29px"
                      />
                    </div>
                    <jd-button
                      v-else
                      type="blueText"
                      label="自定义上传"
                      :disabled="backgroundOpacity"
                    ></jd-button>
                  </el-upload>
                  <jd-button
                    type="blueText"
                    @click="customerPaperwork.productModuleBtnUrl = ''"
                    style="margin: 0 16px 0 16px"
                    :disabled="backgroundOpacity"
                    >重置</jd-button
                  >
                </div>
              </el-form-item>
              <el-form-item label="商品模块按钮文案颜色：" label-width="180px">
                <div class="buttonGroup">
                  <el-color-picker
                    v-model="customerPaperwork.productModuleBtnColor"
                    size="small"
                  ></el-color-picker>
                  <jd-button
                    type="blueText"
                    style="margin: 0 12px 0 16px"
                    @click="customerPaperwork.productModuleBtnColor = currrentRgb3"
                    :disabled="backgroundOpacity"
                    >重置</jd-button
                  >
                </div>
              </el-form-item>
              <el-form-item
                label="砍价阶段icon（按金额砍价）："
                v-if="bargainConfig.bargainType == 0"
                label-width="210px"
              >
                <div class="buttonGroup">
                  <el-upload
                    class="upload"
                    action="/jd-hd-web/image/upload"
                    :show-file-list="false"
                    :before-upload="(file) => beforeUploadUI(file, 2)"
                    :on-success="(res) => handleUploadUI(res, 2)"
                  >
                    <div class="btn-bg" v-if="customerPaperwork.amountStageUrl">
                      <img
                        :src="customerPaperwork.amountStageUrl"
                        style="width: 100%; height: auto"
                      />
                    </div>
                    <jd-button
                      v-else
                      type="blueText"
                      label="自定义上传"
                      :disabled="backgroundOpacity"
                    ></jd-button>
                  </el-upload>
                  <jd-button
                    type="blueText"
                    @click="customerPaperwork.amountStageUrl = ''"
                    style="margin: 0 16px 0 16px"
                    :disabled="backgroundOpacity"
                    >重置</jd-button
                  >
                </div>
              </el-form-item>
              <el-form-item
                label="砍价阶段icon（按邀请人数）："
                label-width="210px"
                v-else
              >
                <div class="buttonGroup">
                  <el-upload
                    class="upload"
                    action="/jd-hd-web/image/upload"
                    :show-file-list="false"
                    :before-upload="(file) => beforeUploadUI(file, 3)"
                    :on-success="(res) => handleUploadUI(res, 3)"
                  >
                    <div class="btn-bg" v-if="customerPaperwork.inviteStageUrl">
                      <img
                        :src="customerPaperwork.inviteStageUrl"
                        style="width: 68px; height: 68px"
                      />
                    </div>
                    <jd-button
                      v-else
                      type="blueText"
                      label="自定义上传"
                      :disabled="backgroundOpacity"
                    ></jd-button>
                  </el-upload>
                  <jd-button
                    type="blueText"
                    @click="customerPaperwork.inviteStageUrl = ''"
                    style="margin: 0 16px 0 16px"
                    :disabled="backgroundOpacity"
                    >重置</jd-button
                  >
                </div>
              </el-form-item>
              <el-form-item label="icon内文案颜色：" label-width="180px">
                <div class="buttonGroup">
                  <el-color-picker
                    v-model="customerPaperwork.stageColor"
                    size="small"
                  ></el-color-picker>
                  <jd-button
                    type="blueText"
                    style="margin: 0 12px 0 16px"
                    @click="customerPaperwork.stageColor = currrentRgb5"
                    :disabled="backgroundOpacity"
                    >重置</jd-button
                  >
                </div>
              </el-form-item>
              <el-form-item label="主按钮背景图：" label-width="180px">
                <div class="buttonGroup">
                  <el-upload
                    class="upload"
                    action="/jd-hd-web/image/upload"
                    :show-file-list="false"
                    :before-upload="(file) => beforeUploadUI(file, 4)"
                    :on-success="(res) => handleUploadUI(res, 4)"
                  >
                    <div class="btn-bg" v-if="customerPaperwork.mainBtnUrl">
                      <img
                        :src="customerPaperwork.mainBtnUrl"
                        style="width: 292px; height: 48px"
                      />
                    </div>
                    <jd-button
                      v-else
                      type="blueText"
                      label="自定义上传"
                      :disabled="backgroundOpacity"
                    ></jd-button>
                  </el-upload>
                  <jd-button
                    type="blueText"
                    @click="customerPaperwork.mainBtnUrl = ''"
                    style="margin: 0 16px 0 16px"
                    :disabled="backgroundOpacity"
                    >重置</jd-button
                  >
                </div>
              </el-form-item>
              <el-form-item label="主按钮文案颜色：" label-width="180px">
                <div class="buttonGroup">
                  <el-color-picker
                    v-model="customerPaperwork.mainBtnColor"
                    size="small"
                  ></el-color-picker>
                  <jd-button
                    type="blueText"
                    style="margin: 0 12px 0 16px"
                    @click="customerPaperwork.mainBtnColor = currrentRgb"
                    :disabled="backgroundOpacity"
                    >重置</jd-button
                  >
                </div>
              </el-form-item>
              <el-form-item label="变量文案颜色：" label-width="180px">
                <div class="buttonGroup">
                  <el-color-picker
                    v-model="customerPaperwork.variableColor"
                    size="small"
                  ></el-color-picker>
                  <jd-button
                    type="blueText"
                    style="margin: 0 12px 0 16px"
                    @click="customerPaperwork.variableColor = currrentRgb4"
                    :disabled="backgroundOpacity"
                    >重置</jd-button
                  >
                </div>
              </el-form-item>
              <el-form-item label="阶段进度条颜色（左）：" label-width="180px">
                <div class="buttonGroup">
                  <el-color-picker
                    v-model="customerPaperwork.progressLeftColor"
                    size="small"
                  ></el-color-picker>
                  <jd-button
                    type="blueText"
                    style="margin: 0 12px 0 16px"
                    @click="customerPaperwork.progressLeftColor = currrentRgb6"
                    :disabled="backgroundOpacity"
                    >重置</jd-button
                  >
                </div>
              </el-form-item>
              <el-form-item label="阶段进度条颜色（右）：" label-width="180px">
                <div class="buttonGroup">
                  <el-color-picker
                    v-model="customerPaperwork.progressRightColor"
                    size="small"
                  ></el-color-picker>
                  <jd-button
                    type="blueText"
                    style="margin: 0 12px 0 16px"
                    @click="customerPaperwork.progressRightColor = currrentRgb7"
                    :disabled="backgroundOpacity"
                    >重置</jd-button
                  >
                </div>
              </el-form-item>
            </template>
          </activityPageSettings>
          <jd-title label="进店设置" type="bold"></jd-title>
          <el-form-item label="进店逛逛:">
            <el-radio-group
              v-model="ruleDTO.goShopSetting"
              :disabled="activityData.isStart"
              @change="onShopSetChange"
            >
              <el-radio :label="0">进入店铺首页</el-radio>
              <el-radio :label="1">跳转指定小程序</el-radio>
              <el-radio :label="2">进入指定链接</el-radio>
            </el-radio-group>
            <div style="color: #f56c6c">
              部分活动需要配合曝光商品使用，如幸运抽奖、裂变神券
            </div>
          </el-form-item>
          <div v-if="ruleDTO.goShopSetting == 1">
            <el-form-item label="小程序appId:" required>
              <el-input
                type="textarea"
                placeholder="请输入小程序appId"
                style="width: 425px; margin-left: 8px"
                show-word-limit
                v-model="ruleDTO.goShopAppId"
                :maxlength="1000"
                :disabled="activityData.isStart"
              ></el-input>
            </el-form-item>
            <el-form-item label="页面路径path:">
              <el-input
                type="textarea"
                placeholder="请输入小程序页面路径path"
                style="width: 425px; margin-left: 8px"
                show-word-limit
                v-model="ruleDTO.goShopUrl"
                :maxlength="1000"
                :disabled="activityData.isStart"
              ></el-input>
              <div style="color: #f56c6c">
                注意：path若不写，则默认进入小程序主页。
              </div>
            </el-form-item>
          </div>
          <el-form-item
            label="指定链接:"
            required
            v-if="ruleDTO.goShopSetting == 2"
          >
            <el-input
              type="textarea"
              placeholder="请输入指定链接"
              style="width: 425px; margin-left: 8px"
              show-word-limit
              v-model="ruleDTO.goShopUrl"
              :maxlength="1000"
              :disabled="activityData.isStart"
            ></el-input>
            <div style="color: #f56c6c">
              注意：仅可填写京东域内的
              H5页面地址，不可设置外链。参考链接：https://m.jd.com/。
            </div>
          </el-form-item>
          <exposureList
            :defaultExposureSwitch.sync="ruleForm.isExposureItem"
            v-model="itemListFor"
            :backgroundOpacity="backgroundOpacity"
            :isLimit="true"
          ></exposureList>
          <sharFrom :sharePic="sharePic" v-model="ruleDTO"></sharFrom>
          <activityRules
            :isForceRemind.sync="isForceRemind"
            :isKeyActivity.sync="isKeyActivity"
            :placementPosition.sync="placementPosition"
            :activityData="activityData"
            :valueRow="valueRow"
            v-model="ruleForm.ruleDescription"
            @generateRule="generateRule"
          ></activityRules>
        </el-form>
      </div>
    </div>
    <div class="create_bottom" v-if="localStepNum == 0 || localStepNum == 1">
      <jd-button
        v-if="localStepNum != 0"
        v-show="!itemId"
        style="margin-right: 8px"
        @click="clickLocalStep()"
        >{{ backgroundOpacity ? "返回列表" : "返回上一步" }}</jd-button
      >
      <jd-button @click="saveDraft" style="margin-right: 8px" v-if="hasDraftBtn"
        >保存至草稿箱</jd-button
      >
      <template v-if="!backgroundOpacity">
        <jd-button
          v-show="!itemId"
          v-if="isSave"
          type="blue"
          @click="resetForm"
          v-preventReClick
          >保存设置</jd-button
        >
      </template>

      <jd-button v-show="itemId" style="margin-right: 8px" @click="cancelEdit"
        >取消</jd-button
      >
      <jd-button v-show="itemId" type="blue">保存设置</jd-button>
    </div>

    <!-- 保存设置弹框 -->
    <el-dialog
      title="重要提示"
      :visible.sync="joinBlackList"
      width="800"
      @close="checked = false"
    >
      <div v-loading="saveLoading">
        <div style="line-height: 25px; margin-bottom: 30px">
          <p>
            1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
          </p>
          <p>
            2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
          </p>
        </div>

        <el-checkbox v-model="checked" label="地址" name="partner"
          >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
        >
      </div>
      <div slot="footer" class="dialog-footer">
        <jd-button @click="joinBlackList = false">取 消</jd-button>
        <jd-button
          @click="handleDialogCloseAnoth()"
          type="blue"
          style="margin-left: 8px"
          v-loading="saveLoading"
          >确 定</jd-button
        >
      </div>
    </el-dialog>
    <selectGoods
      v-if="isShowSpecify"
      :isShow="isShowSpecify"
      @close="getSpecifyGoods"
      :selectGoods="showSelectGoods"
      :moduleType="true"
      :skuSearch="true"
      :isLimit="true"
      :limitNum="1"
      :disabled="backgroundOpacity"
    ></selectGoods>
    <!-- 奖品弹窗 -->
    <selectProduct
      ref="selectProductRef"
      v-if="isShowPrize"
      :echoDate="echoDate"
      :num="1"
      :actId="valueRow"
      :JingdouCount="JingdouCount"
      :isBindGoods="isBindGoods"
      :specifyId="specifyId"
      :isShowGiftCard="false"
      :isShowHongBao="false"
      :isShowPLUS="false"
      :isShowIQY="false"
      :isShowEK="false"
      :isShowThing="false"
      :isShowJingdou="false"
      :isShowCoupon="false"
      :hideShopPoints="true"
      :hasSelectIds="hasSelectIds"
      defaultSelect="twelve"
      @choose-shop="getTheData"
    >
    </selectProduct>
    <!-- 增加奖品弹窗 -->
    <addPrizeNum
      :isShowAddNum="isShowAddNum"
      :prizeData="toAddItem"
      @confirm="confirmAdd"
      @close="isShowAddNum = false"
    />
  </div>
</template>

<script>
import selectGoods from "@/components/selectGoodsMonitor2";
import selectProduct from "./select_product_componentization.vue";
import addPrizeNum from "./components/add-prize-num.vue";
import {
  saveActivityCommon,
  getActivityDetailCommon,
} from "@/api/jhk/integralCenter/PointActivityAnalyticController.js";
import { sellerImage } from "@/api/jhk/paradiseAndTaskCommonController.js";
import { updateCommon } from "@/api/jhk/integralCenter/integralTask";
import { querymemberLevel } from "@/api/jhk/integralCenter/memberLevel";
import informationForm from "./components/informationForm.vue";
import exposureList from "./components/exposureList.vue";
import sharFrom from "./components/sharFrom.vue";
import activityRules from "./components/activityRules.vue";
import activityPageSettings from "./components/activityPageSettings.vue";
import groupBargainingPreviewDialog from "./components/newActPreviews/group-bargaining-preview-dialog.vue";
import dailyLimitConfig from "@/views/interactiveMarketing/activity/components/dailyLimitConfig.vue";
import { useValidateMoreActSet } from "@/views/interactiveMarketing/activity/components/commDataHook/useBasicInformation.js";

export default {
  components: {
    informationForm,
    exposureList,
    sharFrom,
    activityRules,
    activityPageSettings,
    selectGoods,
    selectProduct,
    groupBargainingPreviewDialog,
    addPrizeNum,
    dailyLimitConfig,
  },
  props: {
    itemId: "",
    stepNum: {
      type: Number,
      default: 0,
    },
    activityData: {
      type: Object,
    },
    isSave: {
      type: Boolean,
      default: true,
    },
    valueRow: {
      type: Object,
      default: () => {},
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    },
  },
  watch: {},
  data() {
    return {
      isForceRemind:0,
      isKeyActivity: 0,
      placementPosition: [],
      saveLoading: false,
      hasSelectIds: [],
      toAddItem: {},
      isShowAddNum: false,
      isBindGoods: true,
      prizeIndex: -1,
      JingdouCount: {
        prizeCount: 0,
      },
      isShowPrize: false,
      winLimit: 0,
      showSelectGoods: [],
      isShowSpecify: false,
      defaultLogo: "https://cdn-image.yucrm.cn/hd/images/prizeShow646.png",
      echoDate: {},
      priceObj: {},
      loading: false,
      templateObj: {},
      currrentRgb: "",
      currrentRgb2: "",
      currrentRgb3: "",
      currrentRgb4: "",
      currrentRgb5: "",
      currrentRgb6: "",
      currrentRgb7: "",
      customerPaperwork: {
        title: "拼团砍价",
        desc: "邀请好友帮砍价",
        titleColor: "",
        productModuleBtnUrl: "", //商品模块按钮背景图
        productModuleBtnColor: "", //商品模块按钮文案颜色
        amountStageUrl: "", //砍价阶段icon（按金额砍价）
        inviteStageUrl: "", //砍价阶段icon（按邀请人数）
        stageColor: "", //icon内文案颜色
        mainBtnUrl: "", //主按钮背景图
        mainBtnColor: "", //主按钮文案颜色
        variableColor: "", //变量文案颜色
        progressLeftColor: "", //阶段进度条颜色（左）
        progressRightColor: "", //阶段进度条颜色（右）
      },
      actMember: "1",
      peopleSelected: [],
      templateId: "",
      pageData: {
        size: 10000,
        current: 1,
        total: 0,
      },
      giftList: [],
      itemListFor: [], //商品弹框选择商品数据
      joinBlackList: false,
      checked: false,
      localStepNum: this.stepNum, // 将外部传入的步骤赋值到本地，避免直接更改props
      ruleForm: {
        startTime: "",
        endTime: "",
        condFollow: false,
        ruleDescription: "",
        partner: ["-1"],
        allowLevel: "-1",
        activityName: "",
        openCardFollow: 0,
        firstOpenCardTimeType: 0, // 首次入会时间类型
        openCardBeforeDay: "",
        // 购物条件 - 累计完成订单笔数
        orderCompleteLimitCount: "", // 最小订单笔数
        orderCompleteMaxCount: "", // 最大订单笔数
        // 购物条件 - 累计完成订单金额
        orderCompleteLimitPayment: "", // 最小订单金额
        orderCompleteMaxPayment: "", // 最大订单金额
        // 购物条件 - 最后一次订单完成时间
        lastOrderCompleteTimeType: 0, // 时间类型: 0-不限, 1-距当前天数范围, 2-指定时间段
        lastOrderCompleteStartDay: "", // 距当前开始天数 (当 lastOrderCompleteTimeType='1' 时)
        lastOrderCompleteEndDay: "", // 距当前结束天数 (当 lastOrderCompleteTimeType='1' 时)
        lastOrderCompleteStartTime: "", // 指定开始时间 (当 lastOrderCompleteTimeType='2' 时)
        lastOrderCompleteEndTime: "", // 指定结束时间 (当 lastOrderCompleteTimeType='2' 时)
        isValidBlackList: 0,
      },
      ruleDTO: {
        customerPaperwork: "",
        cusTemplateJSON: "",
        plusObject: 0,
        goShopSetting: 0,
        goShopAppId: "",
        goShopUrl: "",
        // 分享设置
        shareTitle: "",
        shareIntroduce: "",
        sharePic: "",
        openCardStartTime: "",
        openCardEndTime: "",
      },
      bargainConfig: {
        bargainType: 0, //砍价类型
        firstBargainAmountUpperLimit: "",
        firstBargainAmountLowerLimit: "",
        newMemberBargainAmountUpperLimit: "",
        newMemberBargainAmountLowerLimit: "",
        oldMemberBargainAmountUpperLimit: "",
        oldMemberBargainAmountLowerLimit: "",
        inviteLimitType: 0,
      },
      tableInfo: [
        {
          label: "商品图",
          slot: "logoSlot",
        },
        {
          label: "商品名称",
          slot: "titleSlot",
        },
        {
          label: "skuID",
          prop: "skuId",
        },
        {
          label: "京东价",
          slot: "priceSlot",
        },
        {
          label: "操作",
          slot: "actionSlot",
        },
      ],
      specifytList: [
        {
          skuId: "",
          skuName: "",
          logo: "",
          jdPrice: "",
        },
      ],
      sharePic: "",
      activityStartTime: null,
      activityEndTime: null,
      templateJson: {
        templateUItype: "",
      },
      levelList: [],
      isDraft: false,
      prizeList: [
        {
          assetsId: null, // 资产项id(计划id优惠卷id商品id)
          prizeType: 0,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
          reducePrice: null, // 减价
          successInviteNum: null, // 成功邀请人数
        },
        {
          assetsId: null, // 资产项id(计划id优惠卷id商品id)
          prizeType: 0,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
          reducePrice: null, // 减价
          successInviteNum: null, // 成功邀请人数
        },
      ],
      bargainInfo: [
        { label: "奖品名称", prop: "title", minWidth: 180 },
        { label: "奖品类型", slot: "prizeTypeSlot", minWidth: 180 },
        { label: "商品图片", slot: "logoSlot", minWidth: 180 },
        { label: "减价", slot: "discountSlot", minWidth: 180 },
        { label: "优惠后价格", slot: "discountedSlot", minWidth: 180 },
        { label: "奖品库存", slot: "inventorySlot", minWidth: 180 },
        { label: "每日发放限额", slot: "dailyLimit", minWidth: 120 },
        { label: "操作", slot: "actionSlot", minWidth: 200, fixed: "right" },
      ],
      inviteInfo: [
        { label: "成功邀请人数", slot: "inviteSlot", minWidth: 190 },
        { label: "奖品名称", prop: "title", minWidth: 180 },
        { label: "奖品类型", slot: "prizeTypeSlot", minWidth: 180 },
        { label: "商品图片", slot: "logoSlot", minWidth: 180 },
        { label: "减价", slot: "discountSlot", minWidth: 180 },
        { label: "优惠后价格", slot: "discountedSlot", minWidth: 180 },
        { label: "奖品库存", slot: "inventorySlot", minWidth: 180 },
        { label: "每日发放限额", slot: "dailyLimit", minWidth: 120 },
        { label: "操作", slot: "actionSlot", minWidth: 220, fixed: "right" },
      ],
    };
  },
  computed: {
    // 判断是否有草稿箱按钮
    hasDraftBtn() {
      return this.isDraftEdit || !this.valueRow || this.activityData.isCopy;
    },
    commonInfo() {
      return this.bargainConfig.bargainType == 0
        ? this.bargainInfo
        : this.inviteInfo;
    },
    specifyId() {
      return this.specifytList.length > 0 ? this.specifytList[0].skuId : "";
    },
  },
  created() {
    this.sharePic = this.getDefaultSharePic(69);
    this.ruleDTO.sharePic = this.sharePic;
    this.ruleDTO.shareTitle = `我分享了一个${this.activityData.name}活动给你，快来看看吧！`;
    this.ruleDTO.shareIntroduce = `我在京东有新发现，绝对适合你，速来围观～`;
  },
  mounted() {
    this.getLevel();
    this.getDetail();
    this.buriedPoint(1, "拼团砍价", "互动管理", "互动活动");
  },

  methods: {
    getMemberFn(val) {
      this.ruleForm.firstOpenCardTimeType = 0;
      this.ruleForm.openCardBeforeDay = "";
      this.ruleDTO.openCardStartTime = "";
      this.ruleDTO.openCardEndTime = "";
      this.ruleDTO.plusObject = 0;
      this.ruleForm.partner = ["-1"];
      this.peopleSelected = []
    },
    confirmAdd(num) {
      this.$set(this.prizeList[this.prizeIndex], "totalAmount", Number(num));
      this.isShowAddNum = false;
    },
    addStock(row, index) {
      this.toAddItem = {
        ...row,
        num: row.totalAmount,
      };
      this.isShowAddNum = true;
      this.prizeIndex = index;
    },
    changeBargainType(val) {
      if (val == 1) {
        this.bargainConfig.firstBargainAmountUpperLimit = "";
        this.bargainConfig.firstBargainAmountLowerLimit = "";
        this.bargainConfig.newMemberBargainAmountUpperLimit = "";
        this.bargainConfig.newMemberBargainAmountLowerLimit = "";
        this.bargainConfig.oldMemberBargainAmountUpperLimit = "";
        this.bargainConfig.oldMemberBargainAmountLowerLimit = "";
      }
    },
    handlePrizeLimit(row, rowIndex) {
      return this.prizeList.some((item, index) => {
        if (index < rowIndex) {
          if (
            item.prizeType &&
            Number(item.reducePrice) > 0 &&
            Number(item.reducePrice) >= Number(row.reducePrice)
          ) {
            this.$message.warning("当前奖品减价金额需大于前一个奖品的减价金额");
            return true;
          }
        } else if (index > rowIndex) {
          if (
            item.prizeType &&
            Number(item.reducePrice) > 0 &&
            Number(item.reducePrice) <= Number(row.reducePrice)
          ) {
            this.$message.warning("当前奖品减价金额需小于后一个奖品的减价金额");
            return true;
          }
        }
      });
    },
    getDisCountAmount(row, rowIndex) {
      //  TODO: 根据所选择指定商品specifytList的原价和是否填写了优惠后的价格计算减价
      if (row.reducePrice >= this.specifytList[0].jdPrice) {
        row.reducePrice = this.specifytList[0].jdPrice;
      }
      row.price = (this.specifytList[0].jdPrice - row.reducePrice).toFixed(2);
      let flag = this.handlePrizeLimit(row, rowIndex);
      if (flag) {
        row.reducePrice = "";
      }
    },
    getDisCountedPrice(row, rowIndex) {
      //  TODO: 根据所选择指定商品specifytList的原价和是否填写了减价计算优惠后的价格
      if (row.price >= this.specifytList[0].jdPrice) {
        row.price = this.specifytList[0].jdPrice;
      }
      row.reducePrice = (this.specifytList[0].jdPrice - row.price).toFixed(2);
      let flag = this.handlePrizeLimit(row, rowIndex);
      if (flag) {
        row.reducePrice = "";
      }
    },
    addPrizeList() {
      this.prizeList.push({
        assetsId: null, // 资产项id(计划id优惠卷id商品id)
        prizeType: 0,
        price: null,
        logo: null,
        title: "",
        totalAmount: null,
        reducePrice: null, // 减价
        successInviteNum: null, // 成功邀请人数
      });
    },
    selectPrize(row, index) {
      this.prizeIndex = index;
      this.JingdouCount.prizeCount = row.totalAmount;
      this.echoDate = row;
      this.isShowPrize = true;
      this.itemArr = this.prizeList;
      this.hasSelectIds = this.prizeList
        .filter((item) => item.assetsId != row.assetsId)
        .map((item) => item.assetsId + "");
      this.$nextTick(() => {
        this.$refs.selectProductRef.openDialog();
      });
    },
    deletePrize(rowIndex) {
      // 删除商品
      this.prizeList.splice(rowIndex, 1);
    },
    getPriceNum(value) {
      return value
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".")
        .replace(/[^\d.]/g, "")
        .replace(/^(\-)*(\d+)\.(\d).*$/, "$1$2.$3");
    },
    getPriceNumLimit(val, key, type) {
      let str = Number(val.target.value);
      if (str <= 0) {
        return "";
      } else {
        if (type == "first") {
          if (
            this.bargainConfig[key] &&
            str > Number(this.bargainConfig[key])
          ) {
            this.$message.warning("前位金额不可大于后位金额");
            return "";
          }
        } else if (type == "end") {
          if (
            this.bargainConfig[key] &&
            str < Number(this.bargainConfig[key])
          ) {
            this.$message.warning("后位金额不能小于前位金额");
            return "";
          }
        }
        let newStr = str + "";
        console.log(newStr, "bbbb");
        let index = newStr.indexOf(".");
        if (index != -1 && newStr[index + 1]) {
          return str;
        } else if (index != -1 && !newStr[index + 1]) {
          return "";
        }
        return (str + "").indexOf(".") != -1 ? str : str + ".0";
      }
    },
    selectGoodsFn() {
      this.isShowSpecify = true;
    },
    getSpecifyGoods(data) {
      if (data && data.length > 0) {
        this.showSelectGoods = [];
        data.forEach((item) => {
          let obj = {
            skuId: "",
            skuName: "",
            logo: "",
            jdPrice: "",
          };
          obj.skuId = item.skuId;
          obj.skuName =
            (item.wareTitle || item.skuName).length > 12
              ? (item.wareTitle || item.skuName).slice(0, 12)
              : item.wareTitle || item.skuName;
          obj.logo = item.logo;
          obj.jdPrice = item.jdPrice;
          this.showSelectGoods.push(obj);
          this.specifytList = this.showSelectGoods;
        });
      }
      this.isShowSpecify = false;
    },
    //判断尺寸方法 默认200*200
    imgchecked(file, width = 200, height = 200) {
      let _this = this;
      return new Promise((resolve, reject) => {
        let type = file.name
          .substring(file.name.lastIndexOf("."))
          .toLowerCase();
        let sorts = [".png", ".jpg"];
        if (sorts.indexOf(type) < 0) {
          reject();
          this.$message.info("所选图片格式不符，请重新选择");
        } else {
          let image = new Image();
          let _URL = window.URL || window.webkitURL;
          image.onload = function () {
            const valid = image.width == width && image.height == height;
            file.isFlag = valid;
            if (valid) {
              resolve(true);
            } else {
              _this.$message.info("图片尺寸不符合要求，请重新上传");
              reject();
            }
          };
          image.src = _URL.createObjectURL(file);
        }
      });
    },
    async beforeUploadPrize(file) {
      const status = await this.imgchecked(file, 200, 200);
      if (!status) {
        return false;
      }
    },
    uploadLogo(val, row) {
      row.logo = val.data;
    },
    // 背景图上传校验
    async beforeUploadUI(file, type) {
      let sizeype = {
        1: {
          width: 162,
          height: 58,
        },
        2: {
          width: 56,
          height: 56,
        },
        3: {
          width: 136,
          height: 136,
        },
        4: {
          width: 584,
          height: 96,
        },
      };
      const status = await this.imgchecked(
        file,
        sizeype[type].width,
        sizeype[type].height
      );
      if (!status) {
        return false;
      }
    },
    // 背景图上传图片
    handleUploadUI(res, type) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        if (type == 1) {
          this.customerPaperwork.productModuleBtnUrl = res.data;
          this.$message.success("背景图上传成功");
        } else if (type == 2) {
          this.customerPaperwork.amountStageUrl = res.data;
          this.$message.success("砍价阶段icon图上传成功");
        } else if (type == 3) {
          this.customerPaperwork.inviteStageUrl = res.data;
          this.$message.success("砍价阶段icon图上传成功");
        } else if (type == 4) {
          this.customerPaperwork.mainBtnUrl = res.data;
          this.$message.success("背景图上传成功");
        }
      }
    },
    getPrizeCommon(data, prizeType) {
      //处理奖品返回字段公共部分
      let prizeObj = {
        price: "",
        assetsId: "",
        logo: "",
        prizeType: "",
        title: "",
      };
      if (prizeType == 1) {
        prizeObj.couponType = data.couponType;
        prizeObj.goShopSetting = data.goShopSetting;
        prizeObj.goShopAppId = data.goShopAppId;
        prizeObj.goShopUrl = data.goShopUrl;
      }
      if (data.giftType) {
        prizeObj.giftType = Number(data.giftType);
      }
      prizeObj.price =
        prizeType == 13 && data.discount == "" ? "" : Number(data.discount);

      prizeObj.assetsId = data.couponId ? Number(data.couponId) : data.skuId;
      prizeObj.logo = data.logo || this.defaultLogo;
      prizeObj.prizeType = prizeType;

      if (prizeType == 4) {
        prizeObj.title = data.discount + "店铺积分";
      } else {
        prizeObj.title = data.name;
      }

      if (data.singleAmount) {
        prizeObj.singleAmount = data.singleAmount;
      }
      if (prizeType == 2) {
        prizeObj.quantityTotal = data.quantityTotal;
      }
      if (prizeType == 3) {
        if (!data.isGoodManage) {
          prizeObj.skuId = data.skuId;
          delete prizeObj.isGoodManage;
        } else {
          prizeObj.isGoodManage = data.isGoodManage;
        }
        prizeObj.predictSendTime = data.predictSendTime;
        prizeObj.isFollowActivityEndTime = data.isFollowActivityEndTime ? data.isFollowActivityEndTime : 0;
        prizeObj.addressFillEndTime = data.addressFillEndTime;
        prizeObj.addressFillLimit = data.addressFillLimit;
        prizeObj.commitAddressLimit = data.commitAddressLimit;
      }
      // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
      if ([2, 5, 6, 7, 8, 10].includes(Number(prizeType))) {
        prizeObj.budgetRemain = data.budgetRemain;
      }
      if (prizeType == 3 && data.isGoodManage) {
        prizeObj.budgetRemain = data.budgetRemain;
      }
      if (prizeType == 12) {
        prizeObj.reducePrice = data.reducePrice;
      }
      return prizeObj;
    },
    getTheData(data, prizeType) {
      let prizeObj = this.getPrizeCommon(data, prizeType);
      let flag = false;
      if (prizeType == 12) {
        flag = this.handlePrizeLimit(prizeObj, this.prizeIndex);
        // flag = this.prizeList.some((item, index) => {
        //   if (index < this.prizeIndex) {
        //     if (
        //       item.prizeType &&
        //       Number(item.discountAmount) > Number(prizeObj.discountAmount)
        //     ) {
        //       this.$message.warning(
        //         "当前奖品减价金额需大于前一个奖品的减价金额"
        //       );
        //       return true;
        //     }
        //   } else if (index > this.prizeIndex) {
        //     if (
        //       item.prizeType &&
        //       Number(item.discountAmount) < Number(prizeObj.discountAmount)
        //     ) {
        //       this.$message.warning(
        //         "当前奖品减价金额需小于后一个奖品的减价金额"
        //       );
        //       return true;
        //     }
        //   }
        // });
      }
      if (flag) {
        return;
      } else {
        // 阶梯奖品
        this.$set(
          this.prizeList[this.prizeIndex],
          "assetsId",
          prizeObj.assetsId
        );
        this.$set(
          this.prizeList[this.prizeIndex],
          "prizeType",
          prizeObj.prizeType
        );
        this.$set(this.prizeList[this.prizeIndex], "logo", prizeObj.logo);
        this.$set(this.prizeList[this.prizeIndex], "title", prizeObj.title);
        this.$set(this.prizeList[this.prizeIndex], "price", prizeObj.price);
        this.$set(
          this.prizeList[this.prizeIndex],
          "totalAmount",
          this.prizeList[this.prizeIndex].totalAmount
        );
        this.$set(
          this.prizeList[this.prizeIndex],
          "reducePrice",
          prizeObj.reducePrice
        );
        this.$set(
          this.prizeList[this.prizeIndex],
          "successInviteNum",
          this.prizeList[this.prizeIndex].successInviteNum
        );
        this.isShowPrize = false;
      }
    },
    initCustomizeData(row) {
      let configJson = row.configJson && JSON.parse(row.configJson);
      this.customerPaperwork.mainBtnColor = row.rgb;
      this.customerPaperwork.titleColor = row.rgb2;
      this.customerPaperwork.productModuleBtnColor = row.rgb3;
      this.customerPaperwork.stageColor = configJson.rgb5;
      this.customerPaperwork.variableColor = configJson.rgb4;
      this.customerPaperwork.progressLeftColor = configJson.rgb6;
      this.customerPaperwork.progressRightColor = configJson.rgb7;
      this.currrentRgb = row.rgb;
      this.currrentRgb2 = row.rgb2;
      this.currrentRgb3 = row.rgb3;
      this.currrentRgb4 = configJson.rgb4;
      this.currrentRgb5 = configJson.rgb5;
      this.currrentRgb6 = configJson.rgb6;
      this.currrentRgb7 = configJson.rgb7;
    },
    selectTemplate(index, id, item) {
      this.templateObj = item;
      this.templateId = id;
      this.templateJson.templateUItype = index;
      this.initCustomizeData(item);
    },
    onShopSetChange() {
      this.ruleDTO.goShopAppId = "";
      this.ruleDTO.goShopUrl = "";
    },

    // 选择人群关闭
    selectPeopleSure(val) {
      this.peopleSelected = val.map((item) => item.id);
    },
    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate = Date.parse(new Date());
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if (nowDate > startDate) {
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      } else {
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }

      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },

    // 模板类型
    async hdTaskTemplateGroup() {
      this.getPolite();
    },

    // 活动模板
    async getPolite() {
      let params = {
        current: this.pageData.current,
        size: this.pageData.size,
        templateGroupId: "",
        source: 4,
        hdTaskType: this.activityData.id,
      };
      const { data } = await sellerImage(params);
      this.giftList =
        data.records && data.records.length > 0
          ? data.records.map((item) => {
              return {
                ...item,
                days: item.activityStartTime
                  ? this.getDaysBetween(
                      item.activityStartTime,
                      item.activityEndTime
                    )
                  : "",
              };
            })
          : [];
      if (!this.templateId && this.giftList.length > 0) {
        this.templateObj = this.giftList[0];
        this.templateId = this.giftList[0].id;
        this.templateJson.templateUItype = 0;
        this.initCustomizeData(this.templateObj);
      } else if (this.templateId) {
        let arr = this.giftList.filter((item) => item.id == this.templateId);
        this.templateObj = arr[0];
        this.templateId = this.templateId;
        let configJson =
          this.templateObj.configJson &&
          JSON.parse(this.templateObj.configJson);
        this.currrentRgb = this.templateObj.rgb;
        this.currrentRgb2 = this.templateObj.rgb2;
        this.currrentRgb3 = this.templateObj.rgb3;
        this.currrentRgb4 = configJson.rgb4;
        this.currrentRgb5 = configJson.rgb5;
        this.currrentRgb6 = configJson.rgb6;
        this.currrentRgb7 = configJson.rgb7;
        this.customerPaperwork.titleColor = this.customerPaperwork.titleColor;
        this.customerPaperwork.productModuleBtnColor =
          this.customerPaperwork.productModuleBtnColor;
        this.customerPaperwork.stageColor = this.customerPaperwork.stageColor;
        this.customerPaperwork.mainBtnColor =
          this.customerPaperwork.mainBtnColor;
        this.customerPaperwork.variableColor =
          this.customerPaperwork.variableColor;
        this.customerPaperwork.progressLeftColor =
          this.customerPaperwork.progressLeftColor;
        this.customerPaperwork.progressRightColor =
          this.customerPaperwork.progressRightColor;
      }
      this.pageData.total = data.total * 1;
    },
    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
        })
        .catch((res) => {});
    },
    //生成规则
    generateRule() {
      let text1 = "",
        text2 = "活动参与对象：",
        text3 = "",
        text4 = "",
        text5 =
          "每个活动周期内，每位用户仅可领取1次优惠购买资格" + "\n" + "优惠商品数量有限，先达成条件者先得，发完即止" + "\n" + "具体商品列表及专享价详见活动页面说明\n\n",
        text6 =
          "进入活动：用户点击活动入口进入活动页面\n成为会员：若活动要求会员身份，需先完成店铺会员注册/登录\n领取砍价资格：点击“立即参与”获取个人砍价任务\n邀请好友助力：通过分享链接邀请好友帮忙砍价\n领取优惠价资格：达成指定砍价目标后，即可领取对应商品专享价购买资格",
        text7 =
          "通过好友分享的链接/海报进入活动页\n点击“帮好友砍一刀”为好友助力\n可选择“我也要参与”跳转至主参与流程",
        text8 = "",
        text9 = "",
        text10 =
          "1、资格获得\n在活动倒计时结束前达成任一阶段目标，即可领取对应专享价&令牌资格\n领取后资格将发放至您的账户，可在指定时间内使用",
        text11 =
          "1、用户身份识别\n同一用户指同一账号、手机号、设备ID、支付账号、收货地址或身份信息等任一或多项相同的用户\n如发现用户注册或多个账号参与活动，平台有权取消其资格并追回奖励\n2、行为规范\n严禁使用外挂、脚本、虚拟号码、批量注册等非正常手段参与活动\n严禁虚假分享、刷量作弊、恶意套利等行为\n违规用户将被取消资格，并可能限制参与平台其他活动\n" +
          "3、活动调整\n如遇不可抗力、系统故障或政策原因，平台可能调整、暂停或终止活动\n活动规则如有变更，将以页面公示为准，不再另行通知\n4、奖品说明\n专享价资格不可折现、转赠或兑换其他商品\n实物商品发货后如无质量问题不支持退换，请联系客服处理\n5、其他\n如有疑问请联系店铺客服或查看活动页面常见问题解答",
        firstText = "一、【活动基本信息】",
        firstDesc = "【活动时间与对象】\n",
        secondDesc = "4.活动商品及专享价资格",
        secondText = "\n二、【参与方式与流程】",
        secondSubtitleOne = "主参与流程\n",
        secondSubtitleTwo = "被邀请用户流程\n",
        thirdText = "\n三、【场景化规则说明】",
        thirdSubtitleOne = "参与方式",
        thirdSubtitleTwo = "阶段目标示例",
        fourthText = "\n四、【获奖与兑换规则】",
        fiveText = "\n五、【注意事项】";
      const {firstTextStr,precautions} = this.getCommonText(this.levelList,this.ruleForm,this.ruleDTO,this.actMember,false);
      let myfirstTextStr = firstTextStr;
      if (this.bargainConfig.bargainType == 0) {
        text8 += "【邀请好友砍金额】";
      } else if (this.bargainConfig.bargainType == 1) {
        text8 += "【邀请好友人数】";
      }
      secondDesc += "\n" + text5;
      myfirstTextStr += secondDesc;
      secondSubtitleOne += text6;
      secondSubtitleTwo += text7;

      thirdText += "\n" + text8;
      if(this.bargainConfig.bargainType == 0) {
        text9 = "用户发起砍价后，首先自己可获得一次随机砍价金额\n随后邀请好友助力，每位好友可帮助砍掉一定金额"
      } else {
        text9 = "用户发起任务后，需邀请指定数量的好友成功进入活动页并点击助力"
      }
      thirdSubtitleOne += "\n" + text9;
      fourthText += "\n" + text10;
      // fiveText += "\n" + text11;
      fiveText += "\n" + '1.' + precautions;

      // 阶段目标示例
      let indexStatus = {
        0: "一",
        1: "二",
        2: "三",
      };
      let inviteText = "注：每位用户仅可选择领取其中一档优惠价资格";
      let inviteText2 = "";
      if (this.bargainConfig.inviteLimitType == 0) {
        inviteText2 = "每日每位用户可为最多一位好友助力";
      }

      let inviteText3 = "同一好友仅可为同一用户助力1次";
      let inviteText4 = "邀请规则";
      let allInviteText = "";
      if (this.bargainConfig.bargainType == 0) {
        if (this.bargainConfig.inviteLimitType == 0) {
          allInviteText = inviteText + "\n" + inviteText2 + "\n" + inviteText3;
        } else {
          allInviteText = inviteText + "\n" + inviteText3;
        }
      } else if (this.bargainConfig.bargainType == 1) {
        if (this.bargainConfig.inviteLimitType == 0) {
          allInviteText =
            inviteText +
            "\n" +
            inviteText4 +
            "\n" +
            inviteText2 +
            "\n" +
            inviteText3;
        } else {
          allInviteText = inviteText + "\n" + inviteText4 + "\n" + inviteText3;
        }
      }

      if (
        this.prizeList.length > 0 &&
        this.prizeList.some((item) => item.prizeType)
      ) {
        let stage = this.prizeList.map((item, index) => {
          return `阶段${indexStatus[index]}：${
            this.bargainConfig.bargainType == 0
              ? "累计砍掉 ¥" + item.reducePrice
              : "成功邀请" + item.successInviteNum + "人"
          } → 可领取【减价${item.reducePrice}元】优惠资格`;
        });
        thirdSubtitleTwo += "\n" + stage.join("\n") + "\n" + allInviteText;
      }

      let Arr1 = [
        [secondText, secondSubtitleOne, secondSubtitleTwo],
        [thirdText, thirdSubtitleOne, thirdSubtitleTwo],
        [fourthText],
        [fiveText],
      ];
      let newText = "";

      Arr1.forEach((item, index) => {
        let newNum = 0;
        item.forEach((row, it) => {
          if (row.length > 0) {
            if (it != 0) {
              newText = newText + newNum + "、" + row + "\n";
            } else {
              newText = newText + row + "\n";
            }
            newNum = newNum + 1;
          }
        });
      });
      this.ruleForm.ruleDescription = myfirstTextStr + newText.trim();
    },
    // 返回上一步
    returnBack() {
      if (this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      if (this.localStepNum == 0) this.$emit("returnBack");
      if (this.localStepNum == 1) this.localStepNum = 0;
    },
    // 取消编辑
    cancelEdit() {
      this.$emit("cancelEdit");
    },
    //深拷贝
    deepClone(obj) {
      let theObj = JSON.stringify(obj),
        objClone = JSON.parse(theObj);
      return objClone;
    },

    // 下一步
    resetForm() {
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      //活动时间的限制
      if (!this.ruleForm.startTime || !this.ruleForm.endTime) {
        this.$message.warning("请输入活动时间");
        return;
      }
      //活动对象限制
      if (
        this.actMember == 2 &&
        (!this.ruleForm.partner || this.ruleForm.partner.length == 0)
      ) {
        this.$message.warning("请选择活动对象");
        return;
      }
      if (this.actMember == 3 && !this.peopleSelected.length) {
        this.$message.warning("请选择指定人群");
        return;
      }

      // 1.14迭代 这里判断 指定入会时间
      if (this.actMember == "2") {
        if (
          this.ruleForm.firstOpenCardTimeType == 1 &&
          !this.ruleForm.openCardBeforeDay
        ) {
          return this.$message.warning("请完善首次入会时间");
        }
        if (
          this.ruleForm.firstOpenCardTimeType == 2 &&
          (!this.ruleDTO.openCardStartTime || !this.ruleDTO.openCardEndTime)
        ) {
          return this.$message.warning("请完善首次入会时间");
        }
        // 最后一次订单完成时间
        if (
          this.ruleForm.lastOrderCompleteTimeType == 1 &&
          !this.ruleForm.lastOrderCompleteEndDay &&
          !this.ruleForm.lastOrderCompleteStartDay
        ) {
          return this.$message.warning("最后一次订单完成时间");
        }

        if (
          this.ruleForm.lastOrderCompleteTimeType == 2 &&
          !this.ruleForm.lastOrderCompleteStartTime &&
          !this.ruleForm.lastOrderCompleteEndTime
        ) {
          return this.$message.warning("最后一次订单完成时间");
        }
      }

      if (
        this.specifytList.length > 0 &&
        this.specifytList.some((item) => !item.skuName)
      ) {
        return this.$message.warning("请选择指定商品");
      }
      if (this.bargainConfig.bargainType == 0) {
        if (
          !this.bargainConfig.firstBargainAmountUpperLimit ||
          !this.bargainConfig.firstBargainAmountLowerLimit
        ) {
          return this.$message.warning("请完善砍价金额");
        }
        if (
          !this.bargainConfig.newMemberBargainAmountUpperLimit ||
          !this.bargainConfig.newMemberBargainAmountLowerLimit
        ) {
          return this.$message.warning("请完善邀请新会员砍价金额");
        }
        if (
          !this.bargainConfig.oldMemberBargainAmountUpperLimit ||
          !this.bargainConfig.oldMemberBargainAmountLowerLimit
        ) {
          return this.$message.warning("请完善邀请老会员砍价金额");
        }
      }

      // 奖品配置校验
      let flag = this.prizeList.some((item) => {
        if (this.bargainConfig.bargainType == 0) {
          return (
            !item.prizeType &&
            !item.reducePrice &&
            !item.price &&
            !item.totalAmount
          );
        } else {
          return (
            !item.prizeType &&
            !item.reducePrice &&
            !item.price &&
            !item.totalAmount &&
            !item.successInviteNum
          );
        }
      });
      if (flag) {
        return this.$message.warning("请完善奖品配置");
      }

      if (!this.templateId) {
        return this.$message.warning("请选择活动模板");
      }
      // 公活动配置校验
      if (!useValidateMoreActSet(this)) {
        return;
      }

      //新增进店设置校验
      if (this.ruleDTO.goShopSetting == 1 && !this.ruleDTO.goShopAppId) {
        this.$message.warning("请输入小程序appId");
        return;
      }
      if (this.ruleDTO.goShopSetting == 2) {
        if (!this.ruleDTO.goShopUrl) {
          this.$message.warning("请输入指定链接");
          return;
        } else if (
          !this.ruleDTO.goShopUrl.startsWith("https://") ||
          !this.ruleDTO.goShopUrl.includes("jd.com")
        ) {
          this.$message.warning(
            "输入的内容非链接或为接口无法支持的链接，请重新设置"
          );
          return;
        }
      }
      // 小程序分享标题
      if (!this.ruleDTO.shareTitle) {
        this.$message.warning("请输入小程序分享标题");
        return;
      }
      // 小程序分享简介
      if (!this.ruleDTO.shareIntroduce) {
        this.$message.warning("请输入小程序分享简介");
        return;
      }
      if (!this.ruleForm.ruleDescription) {
        this.$message.warning("请输入活动规则");
        return;
      }
      if (this.ruleForm.isExposureItem && this.itemListFor.length == 0) {
        this.$message.warning("请选择曝光商品");
        return;
      }
      if(this.placementPosition.length==0) {    
        this.$message.warning("请选择活动投放位置！");
        return
      }
      this.joinBlackList = true;
    },
    // 保存草稿
    saveDraft() {
      //活动名称的限制
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      if (this.isDraftEdit) {
        this.$confirm("是否保存对当前草稿的修改?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      } else {
        this.$confirm("是否存为草稿?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      }
    },
    async handleDialogCloseAnoth() {
      let ruleDTO = {
        ...this.ruleDTO,
        openCardFollow: this.ruleForm.openCardFollow,
        firstOpenCardTimeType: this.ruleForm.firstOpenCardTimeType,
        openCardBeforeDay: this.ruleForm.openCardBeforeDay,
        isForceRemind: this.isForceRemind,
        ...this.bargainConfig,
        bargainGood: this.specifytList[0],
      };
      let obj = {
        ...this.ruleForm,
        subType: 69,
        ruleDTO,
        pointActivityPrizeDTOList: [],
        isKeyActivity: this.isKeyActivity,
        placementPosition: this.placementPosition.join(","),
      };
      let list = this.prizeList.filter((item) => item.prizeType > 0).map((item) => {
        const prize = { ...item };
        // 提交地址限制：数组转逗号分隔字符串
        if (item.prizeType == 3 && Array.isArray(item.commitAddressLimit)) {
          prize.commitAddressLimit = item.commitAddressLimit.join(',');
        }
        return prize;
      });
      obj.pointActivityPrizeDTOList = list;
      obj.condFollow = Number(this.ruleForm.condFollow);
      obj.ruleDTO.openCardStartTime =
        this.actMember == 2 ? this.ruleDTO.openCardStartTime : "";
      obj.ruleDTO.openCardEndTime =
        this.actMember == 2 ? this.ruleDTO.openCardEndTime : "";
      obj.ruleDTO.plusObject = this.ruleDTO.plusObject;
      // 其他活动页配置
      obj.ruleDTO.customerPaperwork = JSON.stringify(this.customerPaperwork);

      //曝光商品集合设置
      obj.priceType = 0;
      obj.isExposureItem = this.ruleForm.isExposureItem ? 1 : 0;
      obj.itemList = this.itemListFor;

      // 模板
      obj.templateJson = this.templateJson;
      obj.templateId = this.templateId;

      // 活动对象处理
      // 参与会员等级：-1(全部)，0(非会员)，其余填会员等级,
      obj.allowLevel =
        this.ruleForm.partner && this.ruleForm.partner.length
          ? this.ruleForm.partner.join(",")
          : "";

      if (this.actMember == 1) {
        obj.allowLevel = "-1";
      } else if (this.actMember == 3) {
        obj.allowLevel = "99";
        obj.crowdIds = this.peopleSelected.join(",");
      } else if (this.actMember == 2) {
        obj.allowLevel =
          this.ruleForm.partner && this.ruleForm.partner.length
            ? this.ruleForm.partner.join(",")
            : "";
        if (obj.allowLevel == "-1") {
          //会员等级设置
          let list = ["-1", "0"];
          this.levelList.forEach((item, index) => {
            let num = index + 1;
            list.push(num);
          });
          obj.allowLevel = list.join(",");
        }
      }
      // obj.ruleDTO.cusType = this.actMember == 2 ? this.ruleDTO.cusType : 0;
      obj.ruleDTO.orderCompleteLimitCount =
        this.ruleForm.orderCompleteLimitCount;
      obj.ruleDTO.orderCompleteMaxCount = this.ruleForm.orderCompleteMaxCount;
      obj.ruleDTO.orderCompleteLimitPayment =
        this.ruleForm.orderCompleteLimitPayment;
      obj.ruleDTO.orderCompleteMaxPayment =
        this.ruleForm.orderCompleteMaxPayment;
      obj.ruleDTO.lastOrderCompleteTimeType =
        this.ruleForm.lastOrderCompleteTimeType;
      if (obj.ruleDTO.lastOrderCompleteTimeType == 1) {
        obj.ruleDTO.lastOrderCompleteStartDay =
          this.ruleForm.lastOrderCompleteStartDay;
        obj.ruleDTO.lastOrderCompleteEndDay =
          this.ruleForm.lastOrderCompleteEndDay;
      } else if (obj.ruleDTO.lastOrderCompleteTimeType == 2) {
        obj.ruleDTO.lastOrderCompleteStartTime =
          this.ruleForm.lastOrderCompleteStartTime;
        obj.ruleDTO.lastOrderCompleteEndTime =
          this.ruleForm.lastOrderCompleteEndTime;
      }
      delete obj.partner;
      delete obj.openCardFollow;
      delete obj.firstOpenCardTimeType;
      delete obj.openCardBeforeDay;
      delete obj.orderCompleteLimitCount;
      delete obj.orderCompleteMaxCount;
      delete obj.orderCompleteLimitPayment;
      delete obj.orderCompleteMaxPayment;
      delete obj.lastOrderCompleteTimeType;
      delete obj.lastOrderCompleteStartDay;
      delete obj.lastOrderCompleteEndDay;
      delete obj.lastOrderCompleteStartTime;
      delete obj.lastOrderCompleteEndTime;
      if (this.checked == true || this.isDraft) {
        this.saveLoading = true;
        if (this.activityData.isStart) {
          let params = {
            activityId: this.valueRow.id,
            ruleDescription: obj.ruleDescription,
            prizes: this.prizeList.map((item) => {
              const prize = {
                ...item,
                prizeId: item.id,
                title: item.title,
              };
              // 提交地址限制：数组转逗号分隔字符串
              if (item.prizeType == 3 && Array.isArray(item.commitAddressLimit)) {
                prize.commitAddressLimit = item.commitAddressLimit.join(',');
              }
              return prize;
            }),
            isExposureItem: this.ruleForm.isExposureItem ? 1 : 0, //曝光商品
            itemList: this.ruleForm.isExposureItem ? this.itemListFor : [],
            activityName: obj.activityName,
            condFollow: obj.condFollow ? 1 : 0,
            ruleDto: obj.ruleDTO,
            templateId: this.templateId,
            endTime: this.ruleForm.endTime,
            isValidBlackList: this.ruleForm.isValidBlackList,
          };
          updateCommon(params)
            .then((res) => {
              this.saveLoading = false;
              if (res && res.code == 1) {
                this.joinBlackList = false;
                this.$router.push({
                  name: "throw",
                  query: {
                    id: res.data.id,
                    activityType: res.data.activityType,
                  },
                });
                this.$message.success("修改成功");
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {
              this.saveLoading = false;
            });
        } else {
          if (this.isDraft) {
            obj.status = 5;
            delete obj.templateJson;
          } else {
            // 保存正式活动不需要status
            if (obj.status) delete obj.status;
            if (!this.activityData.isCopy) {
              // 未开始活动修改
              if (this.valueRow && this.valueRow.id) {
                obj.pointActivityId = this.valueRow.id;
                obj.id = this.valueRow.id;
              }
            } else {
              delete obj.templateJson;
            }
          }
          // 草稿箱编辑-添加活动id
          if (this.isDraftEdit) {
            obj.id = this.valueRow.id;
            // 草稿箱不需要传 pointActivityId
            if (obj.pointActivityId) delete obj.pointActivityId;
          }
          saveActivityCommon(obj)
            .then((res) => {
              this.saveLoading = false;
              if (res && res.code == 1) {
                if (this.isDraft) {
                  this.$message.success("保存成功！");
                  this.$emit("returnBack", true);
                } else {
                  this.joinBlackList = false;
                  this.$router.push({
                    name: "throw",
                    query: {
                      id: res.data.id,
                      activityType: res.data.activityType,
                    },
                  });
                  this.$message.success(res.message);
                }
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {
                  this.saveLoading = false;
            });
        }
      } else {
        this.saveLoading = false;
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //获取活动详情
    getDetail() {
      if (this.valueRow && this.valueRow.id) {
        if (this.activityData.isStart) {
          this.bargainInfo.splice(this.bargainInfo.length - 1, 0, {
            label: "剩余库存",
            slot: "remanentAmountSlot",
            minWidth: 180,
          });
          this.inviteInfo.splice(this.inviteInfo.length - 1, 0, {
            label: "剩余库存",
            slot: "remanentAmountSlot",
            minWidth: 180,
          });
          this.bargainInfo.some((item) => {
            if (item.slot == "actionSlot") {
              item.minWidth = 300;
              return true;
            }
          });
          this.inviteInfo.some((item) => {
            if (item.slot == "actionSlot") {
              item.minWidth = 300;
              return true;
            }
          });
        }
        this.loading = true;
        getActivityDetailCommon(this.valueRow.id)
          .then((res) => {
            const {
              activityName,
              startTime,
              endTime,
              ruleDto,
              isExposureItem,
              ruleDescription,
              allowLevel,
              crowdIds,
              condFollow,
              templateId,
              pointActivityPrizeDTOList,
              isKeyActivity,
              placementPosition,
              studentSatus,
            } = res.data;
            const {
              openCardFollow,
              firstOpenCardTimeType,
              openCardBeforeDay,
              isForceRemind,
            } = ruleDto;
            this.ruleForm.activityName =
              activityName + (this.activityData.isCopy ? "复制" : "");

            this.ruleForm.condFollow = condFollow ? true : false;
            this.ruleForm.isValidBlackList = res.data.isValidBlackList;
            // 学生身份
            this.ruleForm.studentSatus = studentSatus || "";
            // 活动对象配置
            if (allowLevel == "99") {
              this.peopleSelected = crowdIds.split(",");
              this.actMember = "3";
            } else if (allowLevel == "-1") {
              this.actMember = "1";
              this.ruleForm.partner = ["-1"];
            } else {
              this.actMember = "2";
              if (allowLevel.indexOf("-1") != -1) {
                this.ruleForm.partner = ["-1"];
              } else {
                this.ruleForm.partner = allowLevel.split(",");
              }
            }
            this.ruleForm.openCardFollow = openCardFollow;
            this.ruleForm.firstOpenCardTimeType = firstOpenCardTimeType;
            this.ruleForm.openCardBeforeDay = openCardBeforeDay;
            this.ruleDTO = ruleDto;
            // if (this.ruleDTO.cusType != 0) {
            //   this.actMember = "2";
            // }
            this.isForceRemind = isForceRemind;
            this.isKeyActivity = isKeyActivity||0;
            this.placementPosition = placementPosition ? placementPosition.split(",") : ["SHOP"];

            this.ruleForm.orderCompleteLimitCount =
              ruleDto.orderCompleteLimitCount;
            this.ruleForm.orderCompleteMaxCount = ruleDto.orderCompleteMaxCount;
            this.ruleForm.orderCompleteLimitPayment =
              ruleDto.orderCompleteLimitPayment;
            this.ruleForm.orderCompleteMaxPayment =
              ruleDto.orderCompleteMaxPayment;
            this.ruleForm.lastOrderCompleteTimeType =
              ruleDto.lastOrderCompleteTimeType || 0;
            this.ruleForm.lastOrderCompleteStartDay =
              ruleDto.lastOrderCompleteStartDay;
            this.ruleForm.lastOrderCompleteEndDay =
              ruleDto.lastOrderCompleteEndDay;
            this.ruleForm.lastOrderCompleteStartTime =
              ruleDto.lastOrderCompleteStartTime;
            this.ruleForm.lastOrderCompleteEndTime =
              ruleDto.lastOrderCompleteEndTime;

            // 指定商品回显
            this.specifytList = [ruleDto.bargainGood];
            this.showSelectGoods = [ruleDto.bargainGood];
            // 砍价配置回显
            const {
              bargainType,
              firstBargainAmountUpperLimit,
              firstBargainAmountLowerLimit,
              newMemberBargainAmountUpperLimit,
              newMemberBargainAmountLowerLimit,
              oldMemberBargainAmountUpperLimit,
              oldMemberBargainAmountLowerLimit,
              inviteLimitType,
            } = ruleDto;
            this.bargainConfig.bargainType = bargainType;
            this.bargainConfig.firstBargainAmountUpperLimit =
              firstBargainAmountUpperLimit;
            this.bargainConfig.firstBargainAmountLowerLimit =
              firstBargainAmountLowerLimit;
            this.bargainConfig.newMemberBargainAmountUpperLimit =
              newMemberBargainAmountUpperLimit;
            this.bargainConfig.newMemberBargainAmountLowerLimit =
              newMemberBargainAmountLowerLimit;
            this.bargainConfig.oldMemberBargainAmountUpperLimit =
              oldMemberBargainAmountUpperLimit;
            this.bargainConfig.oldMemberBargainAmountLowerLimit =
              oldMemberBargainAmountLowerLimit;
            this.bargainConfig.inviteLimitType = inviteLimitType;

            //奖品回显
            this.prizeList =
              pointActivityPrizeDTOList && pointActivityPrizeDTOList.length
                ? pointActivityPrizeDTOList.map((item) => {
                    // 提交地址限制回显：逗号分隔字符串转数字数组
                    if (item.prizeType == 3) {
                      if (item.commitAddressLimit) {
                        item.commitAddressLimit = typeof item.commitAddressLimit === 'string'
                          ? item.commitAddressLimit.split(',').map(Number)
                          : item.commitAddressLimit;
                      } else {
                        item.commitAddressLimit = [0];
                      }
                    }
                    return item;
                  })
                : [
                    {
                      assetsId: null, // 资产项id(计划id优惠卷id商品id)
                      prizeType: 0,
                      price: null,
                      logo: null,
                      title: "",
                      totalAmount: null,
                      reducePrice: null, // 减价
                      successInviteNum: null, // 成功邀请人数
                    },
                    {
                      assetsId: null, // 资产项id(计划id优惠卷id商品id)
                      prizeType: 0,
                      price: null,
                      logo: null,
                      title: "",
                      totalAmount: null,
                      reducePrice: null, // 减价
                      successInviteNum: null, // 成功邀请人数
                    },
                  ];
            if (ruleDto.customerPaperwork) {
              this.customerPaperwork = JSON.parse(ruleDto.customerPaperwork);
            }
            this.templateId = templateId;
            this.getPolite();
            this.loading = false;
            // v2.5 => 复制不需要回显奖品和规则
            if (!this.activityData.isCopy) {
              this.ruleForm.startTime = startTime;
              this.ruleForm.endTime = endTime;
              this.activityStartTime = startTime;
              this.activityEndTime = endTime;

              this.ruleForm.isExposureItem = isExposureItem ? true : false;
              this.itemListFor = res.data.itemList;
              this.ruleForm.ruleDescription = ruleDescription;
            }
            this.templateJson = JSON.parse(res.data.templateJson);
            if (this.activityData.isCopy) {
              this.prizeList = [
                {
                  assetsId: null, // 资产项id(计划id优惠卷id商品id)
                  prizeType: 0,
                  price: null,
                  logo: null,
                  title: "",
                  totalAmount: null,
                  reducePrice: null, // 减价
                  successInviteNum: null, // 成功邀请人数
                },
                {
                  assetsId: null, // 资产项id(计划id优惠卷id商品id)
                  prizeType: 0,
                  price: null,
                  logo: null,
                  title: "",
                  totalAmount: null,
                  reducePrice: null, // 减价
                  successInviteNum: null, // 成功邀请人数
                },
              ];
              this.ruleForm.ruleDescription = "";
            }
            console.log(this.prizeList, "gfgfg");
          })
          .catch((res) => {
            this.loading = false;
          });
      } else {
        this.activityStartTime = this.$getDate(30)[0];
        this.activityEndTime = this.$getDate(30)[1];
        this.hdTaskTemplateGroup();
      }
    },
    clickLocalStep() {
      if (this.backgroundOpacity) {
        this.$emit("returnBack");
        return;
      }
      if (!this.activityData.isCopy && this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      this.localStepNum = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.createPlayStep {
  min-width: 1046px;
  position: relative;
  box-sizing: border-box;
  height: 100%;
  background-color: #fff;
  border-radius: 6px;
  .secondstep {
    box-sizing: border-box;
    position: relative;
    padding: 28px 28px 1px 24px;
    margin-bottom: 29px;
  }
  .buttonGroup {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: #666;
  }

  .invite-box {
    background-color: #f7f8fa;
    padding: 16px;
    border-radius: 8px;
  }

  .ml12 {
    margin-left: 12px;
  }

  .ml8 {
    margin-left: 8px;
  }

  .ml20 {
    margin-left: 20px;
  }

  .mlr8 {
    margin: 0 8px;
  }

  .w90 {
    width: 90px;
  }
  .w125 {
    width: 125px;
  }
  .w150 {
    width: 150px;
  }
  .w180 {
    width: 180px;
  }

  .tip-color {
    color: #666;
  }

  .logo-style {
    margin-top: 8px;
    width: 80px;
    height: 80px;
  }

  .text-red {
    color: #ff4d4f;
  }
}
</style>
